import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { useIsEdited } from '../../Providers/IsEditedProvider';

export default function InputSwitchElement({ checked, onChange, ...props }) {
    const { setIsEdited } = useIsEdited()
    return (
        <div>
            <InputSwitch

                {...props}
                checked={checked}
                onChange={(e) => {
                    setIsEdited(true);
                    onChange(e);
                }} />
        </div>
    )
}